var map = {
	"./achievements.svg": "2fe9",
	"./add.svg": "876b",
	"./addSquare.svg": "2e86",
	"./broccoli.svg": "835f",
	"./calendar.svg": "6bca",
	"./clock.svg": "0fbd",
	"./close-white.svg": "cb6c",
	"./close.svg": "0572",
	"./dislike.svg": "f791",
	"./download.svg": "0339",
	"./emptyClose.svg": "0ff5",
	"./exclamation.svg": "2651",
	"./filter.svg": "ce2e",
	"./fire.svg": "8a93",
	"./followers.svg": "346f",
	"./gender.svg": "f6ea",
	"./handHello.svg": "42e1",
	"./hashtag.svg": "efcf",
	"./heart.svg": "40ea",
	"./interestsArea.svg": "b6b4",
	"./language.svg": "2a65",
	"./like.svg": "f123",
	"./location.svg": "c411",
	"./menu.svg": "39c4",
	"./play.svg": "4715",
	"./point.svg": "4ec0",
	"./question.svg": "40d9",
	"./sandClock.svg": "fc0d",
	"./search.svg": "f919",
	"./share.svg": "40cf",
	"./views.svg": "ded4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";